let _ = t => t,
  _t;
import _styled from "styled-components";
import { Component } from 'react';
import ContentRoutes from 'ContentUtils/Routes';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'Redu... Remove this comment to see the full error message
import NotificationList from 'ReduxMessenger/components/NotificationList';
import FloatingEditor from '../compose/components/FloatingEditor';
import RequireElevatedJitaPrompt from 'svh-workspace-ui-lib/elevated-jita/RequireElevatedJitaPrompt';
import { NotificationPreemptor } from 'svh-workspace-ui-lib/notifications/public/components';
import DebugOverlay from 'conversations-error-reporting/debug-overlay/DebugOverlay';
import PubSubHealthCheck from '../pubsub/components/PubSubHealthCheck';
import NetworkStatistics from '../performance-reporting/components/NetworkStatistics';
import TopLevelErrorBoundary from '../error-messages/components/TopLevelErrorBoundary';
import { InboxFeedbackLoader } from './InboxFeedbackLoader';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
class Application extends Component {
  constructor(...args) {
    super(...args);
    this.removeSkeletonPreloader = () => {
      const element = document.querySelector('.skeleton-state-preloader');
      if (element && element.parentNode) {
        element.parentNode.removeChild(element);
      }
    };
  }
  componentDidMount() {
    const {
      gates
    } = this.props;
    const nav = document.getElementById('hs-nav-v3');
    if (nav) {
      nav.classList.add('no-bottom-margin');
    }
    ContentRoutes.init(gates);
    this.removeSkeletonPreloader();
  }
  render() {
    if (!this.props.hasConnectedEmailDataAccess) {
      return /*#__PURE__*/_jsx(RequireElevatedJitaPrompt, {
        currentUserEmail: this.props.currentUserEmail,
        portalDomain: this.props.portalDomain
      });
    }
    return /*#__PURE__*/_jsx("div", {
      className: "admin-app-container",
      children: /*#__PURE__*/_jsxs(TopLevelErrorBoundary, {
        children: [/*#__PURE__*/_jsx(_StyledNotificationList, {}), /*#__PURE__*/_jsx(InboxFeedbackLoader, {}), this.props.children, /*#__PURE__*/_jsx(FloatingEditor, {}), /*#__PURE__*/_jsx(DebugOverlay, {
          renderNetworkStatistics: () => {
            return /*#__PURE__*/_jsx(NetworkStatistics, {});
          }
        }), /*#__PURE__*/_jsx(PubSubHealthCheck, {}), /*#__PURE__*/_jsx(NotificationPreemptor, {
          focusedViewMemberThreadId: this.props.focusedViewMemberThreadId
        })]
      })
    });
  }
}
Application.displayName = 'Application';
export default Application;
var _StyledNotificationList = _styled(NotificationList)(_t || (_t = _`
              .alert {
                max-width: 700px;
              }
            `));